import React from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'react-emotion'

import { Popup, Card, Image, Label as SUILabel } from 'util/ui'
import { Label } from 'shared/components/ui/Typography'
import { Header, SubHeader, Text } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

import { doSetFlag, selectIsFetchingFlags, selectFlag } from 'ducks/flags'
import {
  doUpdateUserPreferences,
  selectPrefersClassicView,
} from 'ducks/currentUser'

import classicPreview from 'assets/layout-classic.png'
import modernPreview from 'assets/layout-modern.png'

import GlobalNavItem from './GlobalNavItem'

const StyledPopup = styled(Popup)`
  box-shadow: ${themeVars.floatingShadowHover} !important;
  padding: ${themeVars.big} !important;
  max-width: 728px !important;
  text-align: center;
`

const StyledCardGroup = styled(Card.Group)`
  margin-left: -${themeVars.relative8px} !important;
  margin-right: -${themeVars.relative8px} !important;
`

const StyledCard = styled(Card)`
  position: relative;
  padding: 0 !important;
  width: calc(50% - ${themeVars.relative16px}) !important;
  margin-left: ${themeVars.relative8px} !important;
  margin-right: ${themeVars.relative8px} !important;
  &:not(.raised):hover {
    border-color: ${themeVars.solidBorderColor} !important;
  }
`

const StyleImageContainer = css`
  padding-bottom: 24px !important;
`

const StyleDescription = css`
  padding-top: 0px !important;
`

const StyledLabel = styled(SUILabel)`
  position: absolute !important;
  top: ${themeVars.mini} !important;
  left: -${themeVars.relative7px} !important;
  z-index: 1;
`

const PreviewImage = styled(Image)`
  height: 128px;
`

const flagName = 'has_seen_inbox_layout_switcher'

class InboxLayoutSwitcher extends React.PureComponent {
  // eslint-disable-next-line react/sort-comp
  state = {
    isOpen: false,
  }

  handleOpen = () => {
    this.setState({ isOpen: true })
  }

  handleClose = () => {
    this.setState({ isOpen: false })
  }

  handleClickClassicView = () => {
    const { prefersClassicView, useClassicView } = this.props
    if (!prefersClassicView) {
      useClassicView()
    }
    this.setState({ isOpen: false })
  }

  handleClickModernView = () => {
    const { prefersClassicView, useModernView } = this.props
    if (prefersClassicView) {
      useModernView()
    }
    this.setState({ isOpen: false })
  }

  render() {
    const {
      useClassicView,
      useModernView,
      prefersClassicView,
      flagHasSeen,
      ...rest
    } = this.props
    const { isOpen } = this.state
    return (
      <StyledPopup
        basic
        flowing
        mountNode={app.suiPortalRoot}
        on="click"
        position="top left"
        horizontalOffset={-40}
        verticalOffset={-5}
        trigger={
          <GlobalNavItem
            {...rest}
            title="Layout"
            iconName="inboxLayout"
            size={14}
          />
        }
        open={isOpen}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
      >
        <Header
          as="h1"
          size="medium"
          css={`
            &&& {
              margin-bottom: 0 !important;
              font-family: ${themeVars.walsheim} !important;
            }
          `}
        >
          Choose your layout
        </Header>
        <SubHeader
          as="h2"
          size="tiny"
          css={`
            margin-top: 0 !important;
            margin-bottom: ${themeVars.relative24px} !important;
          `}
        >
          Choose a layout that best suits your day-to-day needs. Change at any
          time.
        </SubHeader>
        <StyledCardGroup stackable centered itemsPerRow={2}>
          <StyledCard
            link
            raised={prefersClassicView}
            as="div"
            id="inbox-layout-3column"
            onClick={this.handleClickClassicView}
            className="nodivider"
          >
            <Card.Content textAlign="center" className={StyleImageContainer}>
              <PreviewImage src={classicPreview} />
            </Card.Content>
            <Card.Header as={Label} size="large">
              3 column view
            </Card.Header>
            <StyledLabel color={themeVars.bioColorName} ribbon size="small">
              {/* You may ask why this StyledLabel is in the middle of two other
                components. Because semantic. That's why. Don't move or you will
                mess up the border radius of the label ribbon. */}
              Brand New
            </StyledLabel>
            <Card.Content textAlign="center" className={StyleDescription}>
              <Text as="p" size="small">
                A simple 3 column layout where you navigate between the email
                list and a selected email.
              </Text>
            </Card.Content>
          </StyledCard>
          <StyledCard
            link
            raised={!prefersClassicView}
            as="div"
            id="inbox-layout-4column"
            onClick={this.handleClickModernView}
            className="nodivider"
          >
            <Card.Content textAlign="center" className={StyleImageContainer}>
              <PreviewImage src={modernPreview} />
            </Card.Content>
            <Card.Header as={Label} size="large">
              4 column view
            </Card.Header>
            <Card.Content textAlign="center" className={StyleDescription}>
              <Text as="p" size="small">
                4 Column layout, showing you both your email list and a selected
                email open at the same time.
              </Text>
            </Card.Content>
          </StyledCard>
        </StyledCardGroup>
      </StyledPopup>
    )
  }
}

const select = state => {
  return {
    prefersClassicView: selectPrefersClassicView(state),
    isFetchingFlags: selectIsFetchingFlags(state),
    hasSeen: selectFlag(state)(flagName),
  }
}

const perform = dispatch => {
  return {
    useClassicView: () =>
      dispatch(doUpdateUserPreferences({ classic_view: true })),
    useModernView: () =>
      dispatch(doUpdateUserPreferences({ classic_view: false })),
    flagHasSeen: () => dispatch(doSetFlag(flagName)),
  }
}

export default connect(select, perform)(InboxLayoutSwitcher)
